import React from 'react';
import { SyncOutlined } from '@ant-design/icons';

export const LoadingScreen = () => (
  <div className="loadingScreen">
    <div>
      <SyncOutlined spin /> Daten werden laden...
    </div>
  </div>
);
